.fileLink {
    text-decoration: none;
    cursor: pointer;
}

.fileLink:hover {
    text-decoration: underline;
}

.icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    vertical-align: -0.125em;
    margin-left: 0.25em;
    flex-shrink: 0;
}

.downloadIcon {
    composes: icon;
    display: none;
}

.fileLink:hover .icon {
    display: none;
}

.fileLink:hover .downloadIcon {
    display: inline-block;
}

.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
}
